exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.book-component-list-item {\n  padding-top: 2px;\n  padding-bottom: 1px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  color: black;\n  white-space: nowrap;\n  display: block;\n}\n.book-component-list-item.book-component-list-item--active {\n    background-color: #0f626b;\n}\n.book-component-list-item.book-component-list-item--active .book-component-list-item__file-name {\n    color: #e4f9fb;\n}\n.book-component-list-item__icon {\n    color: #829268;\n    margin-left: 3px;\n    margin-right: 3px;\n}\n", ""]);

// exports
